
import Calendar from "@/assets/svg/calendar.svg?inline";
import ThreeStrokeBlack from "@/assets/svg/threestrokesblack.svg?inline";
import ThreeStrokeWhite from "@/assets/svg/threestrokeswhite.svg?inline";
import BoxWhite from "@/assets/svg/boxwhite.svg?inline";
import BoxBlack from "@/assets/svg/boxblack.svg?inline";
import ArrowUp from "@/assets/svg/heroicons/arrow-up.svg?inline";
import ArrowDown from "@/assets/svg/heroicons/arrow-down.svg?inline";
import Close from "@/assets/svg/closewhite.svg?inline";

export default {
  components: {
    ArrowDown,
    ArrowUp,
    Calendar,
    ThreeStrokeBlack,
    ThreeStrokeWhite,
    BoxWhite,
    BoxBlack,
    Close,
  },
  props: {
    filterInmobile: {
      type: Boolean,
      default: true,
    },

    title: {
      type: String,
      default: null,
      required: false,
    },
    backgroundImage: {
      type: String,
      default: null,
      required: false,
    },
    view: {
      type: String,
      default: "list",
    },
  },
  data() {
    return {
      isActive: true,
      customDateClicked: false,
      dropdownOpen: false,
      filtered: false,
    };
  },
  watch: {
    filterInmobile(val) {
      this.filtered = val;
    },
    view(val) {
      if (val == "list") {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    clickOutside(onClickOpen) {
      this.dropdownOpen = false;
      this.customDateClicked = false;
    },
    onToggle(onClickOpen) {
      this.dropdownOpen = !this.dropdownOpen;
      onClickOpen();
    },
    updateDate(val) {
      if (!val.start) {
        this.filtered = false;
      } else {
        this.filtered = true;
      }
      document.querySelector(".dropbtn").click();
      this.customDateClicked = false;
      this.$emit("update-date", val);
    },
    setCustomdate(type) {
      if (type === "date") {
        this.customDateClicked = !this.customDateClicked;
      } else {
        this.filtered = true;
        this.customDateClicked = false;
        this.$emit("customdateselected", type);
      }
    },
    toggleClass(event) {
      // Check value
      let view = "list";

      if (this.isActive) {
        view = "card";
      }
      this.isActive = !this.isActive;

      this.$emit("view", view);
    },
  },
};
